// extracted by mini-css-extract-plugin
export default {"navigation-list":"C2Iurl","navigation-list__item":"VovVCN","navigation-list__title":"s5Bs5l","link__text":"sht6yb"};